
export abstract class Basebuilder<T> {
  abstract build (): T;
}
